var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "X") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warmups",
    transform: "translate(-69.000000, -11.000000)",
    stroke: "#7C8796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/@",
    transform: "translate(70.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,8 C11,9.65733333 9.65666667,11 8,11 C6.34333333,11 5,9.65733333 5,8 C5,6.34333333 6.34333333,5 8,5 C9.65666667,5 11,6.34333333 11,8 L11,8 Z",
    id: "Stroke-121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3333333,14.3333333 C11.1,15.18 9.608,15.6666667 8,15.6666667 C3.76533333,15.6666667 0.333333333,12.2346667 0.333333333,8 C0.333333333,3.766 3.76533333,0.333333333 8,0.333333333 C12.2346667,0.333333333 15.6666667,3.766 15.6666667,8 L15.6666667,8.66666667 C15.6666667,9.956 14.622,11 13.3333333,11 C12.0446667,11 11,9.956 11,8.66666667 L11,8",
    id: "Stroke-122"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/at.2aa73e71.svg";
export { ForwardRef as ReactComponent };